<div class="intro-background" [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')'}">
  <div class="product-detail-offer-body" [ngClass]="{'play-product-detail-offer-body': play}">
    <div class="left">
      <img src="{{logoUrl}}" class="intro-logo" [ngClass]="{'play-intro-title-font': play}">
      <h2 class="intro-title" *ngIf="showTitle" [ngClass]="{'play-intro-title-font': play}"
          [innerHTML]="titleKey | translate"></h2>
      <p class="intro-text" [ngClass]="{'play-intro-text-font': play}" [innerHTML]="descriptionKey | translate"></p>
      <div class="buttonContainer">
        <app-order-button *ngIf="pack"
                          [x]="0"
                          [y]="0"
                          [pack]="pack"
                          [superiorSubscribedPack]="superiorSubscribedPack"
                          [ownerComponent]="componentName"
                          (emitOnEnterPressed)="onEmitOrderProduct($event)"
                          (emitOnBack)="onBack()">
        </app-order-button>
        <app-order-button *ngIf="pack && pack.isGroupPack && pack.subscribed"
                          [x]="0"
                          [y]="0"
                          [pack]="pack"
                          [isGroupPack]="pack.isGroupPack"
                          [superiorSubscribedPack]="superiorSubscribedPack"
                          [ownerComponent]="componentName"
                          (emitOnEnterPressed)="onEmitOrderProduct($event)"
                          (emitOnBack)="onBack()">
        </app-order-button>
        <app-play-trailer-button *ngIf="showTrailerButton && !play" [x]="1" [y]="0" [ownerComponent]="componentName"
          [omapiId]="pack?.omapiId" (emitOnEnterPressed)="openTrailer()" (emitOnBack)="closeTrailer()"  [playingTrailer]="isTrailerPlaying">
        </app-play-trailer-button>
      </div>

      <ng-container *ngIf="showQrTile">
        <app-spacer [spacerSize]="40"></app-spacer>
        <app-qr-tile [title]="'eos-tv-shop-ii.title.qr-tile'" [description]="'eos-tv-shop-ii.text.qr-tile-description'" [QRCodeType]="qrCodeType"></app-qr-tile>
      </ng-container>

    </div>
    <div class="right" *ngIf="!isSubscribedStreamingPack">
      <div class="vat-excl-section" *ngIf="pack.isSoho">
        <img src="../../../../assets/images/icon-information.svg" alt="">
        <div class="vat-excl-section--label" [translate]="'eos-tv-shop-ii.vat-excl-lbl'"> All prices are VAT exclusive</div>
      </div>
      <app-price-per-month class="price-position"
                           *ngIf="shouldShowPriceBubble"
                           [class.large]="rendition === defaultRendition"
                           [rendition]=rendition
                           [priceDetail]="pack?.priceDetail"
                           [omapiId]="pack?.omapiId"
                           [textKeyWithParameter]="'price-detail-text-from-price-per-month'"
                           [promoTextKey]="pack?.isStreamingBundle ? 'price-detail-promo-text-from-price-per-month-' + pack.omapiId.toLowerCase() : null"
                           [isPlay]="play"
      ></app-price-per-month>
      <div class="sub-container" *ngIf="subPack">
        <img src="{{subLogoUrl}}" class="sub-intro-logo">
        <p [translate]="subPackDescriptionKey"></p>
        <app-order-button #subPackOrderButton *ngIf="pack && subPack"
                          [x]="subX"
                          [y]="0"
                          [class]="'marginTop'"
                          [pack]="pack"
                          [subPack]="subPack"
                          [superiorSubscribedPack]="superiorSubscribedPack"
                          [ownerComponent]="componentName"
                          (emitOnEnterPressed)="onEmitOrderProduct($event)"
                          (emitOnBack)="onBack()">
        </app-order-button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showFaqs && !isSubscribedStreamingPack">
    <app-spacer [spacerSize]="60"></app-spacer>
    <app-faqs [omapiId]="pack?.omapiId" (emitOnEnterPressed)="openFaqs($event)"></app-faqs>
  </ng-container>

  <ng-container *ngIf="showTermsCta && !isSubscribedStreamingPack">
    <app-spacer [spacerSize]="40"></app-spacer>
    <app-cta-link [omapiId]="pack?.omapiId" [x]="0" [y]="2" (emitOnEnterPressed)="openTAndC($event)"></app-cta-link>
  </ng-container>

  <app-faqs-modal
    [config]="modalConfig"
    *ngIf="modalConfig.showFaq && !isSubscribedStreamingPack"
    (emitCloseFaq)="closeFaqs()"
    [titleKey]="this.selectedFaq.title"
    [descriptionKey]="this.selectedFaq.description"
    [closeButtonTextKey]="'eos-tv-shop-ii.btn.faqs-modal-close'">
  </app-faqs-modal>

  <app-terms-and-conditions-modal
    [config]="modalConfig"
    *ngIf="modalConfig.showTAndC"
    (emitClose)="closeTCModal()"
    [titleKey]="this.termsAndConditionsLabel.title"
    [descriptionKey]="this.termsAndConditionsLabel.description"
    [closeButtonTextKey]="'eos-tv-shop-ii.btn.conditions-modal-close'">
  </app-terms-and-conditions-modal>

</div>
<div *ngIf="isTrailerPlaying">
  <app-trailer [pack]="pack" #trailer (emitExitVideo)="closeTrailer()" [YTvideoId]="trailerId">
  </app-trailer>
</div>
